export class CommonConstants {

    static readonly phoneNumberConstants = {
        mask: '(000) 000-0000',
        placeholder: '(000) 000-0000'
    }
    static readonly appComponent = {
        close: 'Close',
        updatedSuccessfully: 'Updated Successfully',
        addedSuccessfully: 'Added Successfully',
        quickaccountaddedSuccessfully: 'Quick Contact Created successfully.',
        quickaccountupdatedSuccessfully: 'Quick Contact Updated successfully.',
        deletConfirmation: 'Are you Sure you want to delete this record',
        yes: 'Yes',
        no: 'No',
        positiveValueWarning: 'Only positive numeric values are allowed',
        rangeFromAndToWarning: 'Please enter a value between Range From and next Range To value',
        weight: 'WEIGHT',
        infinite: 'infinite',
        multiplier: 'multiplier',
        tier: 'Tier',
        cancel: 'Cancel',
        confirm: 'Confirm',
        somethingWenWrongPleaseReTry: 'Something Went wrong, Please Re-try.',
        error: 'Error!',
        tenantId: 'TenantId',
        isActive: 'IsActive',
        activate: 'Activate',
        deactivate: 'Deactivate',
        all: 'all',
        enterValidDate: 'Please enter From and To date',
        fromCanNotBeGreaterThenTo: 'From date can not be greater then to.',
        toDateCanNotBeLessThenFrom: 'To date can not be less then from.',
        start: 'start',
        end: 'end',
        dateFormat: 'YYYY-MM-DD',
        areYouSure: 'Are you sure?',
        savedSuccessfully: 'Saved Successfully',
        job: 'Job',
        quote: 'Quote',
        alert: 'Alert',
        selectFranchise: 'Please select franchise',
        oidcCNFFranchaiseId: 'oidcCNFFranchaiseId',
        selectAccount: 'Please select a valid Account',
        invalidPhoneNumber: 'Invalid Primary Phone Number',
        selectImage: 'Please select image',
        selectAttachment: 'Please select Attachment',
        toEmailRequired: 'To email is required',
        invalidFileFormat: 'Invalid file Format!',
        noFranchiseInformationAvailable: 'No Franchise Information Available.',
        corp: 'CORP',
        toEmailValidationMessage: 'Email id\'s in To not valid',
        ccEmailValidationMessage: 'Email id\'s in cc not valid',
        bccEmailValidationMessage: 'Email id\'s in bcc not valid',
        descriptionValidationMessage: 'Description is mandatory field',
        activatedSuccessfully: 'Activated Successfully',
        deactivatedSuccessfully: 'Deactivated Successfully',
        orderClonedSuccessMessage: 'Order clone successfully',
        carrierCodesURL: 'https://developer.freightview.com/#section/Carrier-Codes',
        deleteFilesPermanently: 'Are you sure you want to permanently delete file?',
        finalDimsBookingSuccessMessage: 'Quote booked through freight view hence converting into job',
        finalDimsBookingSuccessConvertLeadMessage: 'Quote booked through freight view hence converting into job. Lead converted to customer successfully',
        adminDocumentUploadMessage: 'Upload initiated. File will be uploaded in sometime.',
        delinkAccountMessage: 'You want to delink the Account',
        idleTimeInMinutes: 355,
        emailSuccessMessage: 'Email Sent Successfully',
        shipTo: 'shipTo',
        shipFrom: 'shipFrom',
        shipPayer: 'shipPayer',
        shipIntermediary: 'shipIntermediary',
        warning: 'Warning',
        documentsUploadedSuccessfully: 'Documents Uploaded Successfully',
        clientAccountmarkupMessage: 'Use client account markups?',
        itemDimenionsToasterMessage: 'Item dimensions and weight must be greater than 0',
        serviceUpdatedSuccessMessage: 'Service updated Successfully',
    };

    static readonly yrc = 'YRC';
    static readonly cust = 'CUST';

    static readonly trackingIconConstants = {
        shipmentCreated: 'shipment created',
        inTransit: 'in transit',
        pending: 'pending',
        delivered: 'delivered',
        failed: 'failed'
    };

    static readonly bolFreightView = 'bol-freightview';

    static readonly volumeMinutesCubicFoot = 'This is a method of calculating labor (in minutes) ' +
        'based on the external volume of your build. ' +
        'We use a tiered system that allows you to capture calculations for varying size builds.' +
        'Tier 1 will be your baseline tier. Each tier has its own multiplier.' +
        'We are essentially converting cubic feet into build minutes.<br><br>' +
        '<b>Example: Baseline tier is set to cover 0 to 30 cubic feet. Our multiplier is set to 2.' +
        'The crate materials are then calculated based on your item dims to come up with your outer ' +
        'dimensions and your crate volume. The product of your volume and your multiplier gives you build ' +
        'minutes for that tier. Therefore if your crate build is 30 cubic feet and your multiplier is  2 = 60 ' +
        'build minutes will be calculated.<br><br>' +
        'For larger crates we have to define our second tier = from 30.01 - 60 cubic feet with a multiplier ' +
        'of 1. If your build came out to be 60 cubic feet your total build minutes would be 90. 60 minutes ' +
        'from tier 1 and 30 minutes from tier 2 </b>';

    static readonly linearMinutesFoot = '<b>(Always used in conjunction with Cuts Multiplier)</b> ' +
        'This is a method of calculating labor (in minutes) based on the amount of linear lumber utilized,' +
        'added to the amount of cuts needed in a specific build.' +
        'We use a tiered system that allows you to capture calculations for varying-size builds.' +
        'Tier 1 will be your baseline tier. Each tier has its own multiplier.' +
        'We are essentially converting linear feet into build minutes.<br><br>' +
        'Example: Baseline tier is set to cover 0 to 30 linear feet. Our multiplier is set to 2. ' +
        'The crate materials are then calculated based on your item dims to come up with your materials ' +
        'list. The product of your linear feet of lumber and your multiplier gives you build minutes for ' +
        'that tier. Therefore if your crate build consist of 30 linear feet of lumber and your multiplier is  ' +
        '2 = 60 build minutes will be calculated.<br><br>' +
        'For larger crates we have to define our second tier = from 30.01 - 60 linear feet with a multiplier of ' +
        '1. If your build came out to be 60 linear feet of lumber your linear lumber build minutes would be 90. ' +
        '60 minutes from tier 1 and 30 minutes from tier 2. To calculate your final labor minutes, this would be ' +
        'added to your additional build minutes calculated from cuts.';

    static readonly cutsMinutesCut = '<b>(Always used in conjunction with Cuts Multiplier)</b> ' +
        'This is a method of calculating labor (in minutes) based on the amount of cuts needed for a particular build,' +
        ' added to the amount of linear lumber needed for that build. ' +
        'We use a tiered system that allows you to capture calculations for varying size builds. ' +
        'Tier 1 will be your baseline tier. Each tier has its own multiplier. ' +
        'We are essentially converting lumber/ply cuts into build minutes.<br><br>' +
        'Example: Baseline tier is set to cover 0 to 30 linear feet. Our multiplier is set to 2. ' +
        'The crate materials are then calculated based on your item dims to come up with your materials list. ' +
        'Each stick of lumber counts as 1 cut, each piece of ply counts as 2. The product of your cuts and your ' +
        'multiplier gives you build minutes for that tier. Therefore if your crate build consist of 30 cuts and your ' +
        'multiplier is  2 = 60 build minutes will be calculated.<br><br>' +
        'For larger crates we have to define our second tier = from 30.01 - 60 cuts with a multiplier of 1. ' +
        'If your build came out to be 60 cuts, your build minutes calculated from cutting would be 90. 60 minutes ' +
        'from tier 1 and 30 minutes from tier 2. To calculate your final labor minutes, this would be added to your ' +
        'additional build minutes calculated from linear.';

    // Section -  BoxContainerLaborCalculationGridComponent
    static readonly boxCLCGComponent = {
        tiersDeletedSuccessfully: 'All Tiers Deleted Successfully',
        provideRangeWarning: 'Please provide all Range To values for \'??\'',
        maximumValue: 'maximumValue',
        selectMaterialCategory: 'Please select material category which has default materials',
        modifiers: 'Modifiers',
        isBoxContainerUpdate: 'isBoxContainerUpdate',
        boxContainerFormTopPosition: 'boxContainerFormTopPosition'
    };

    static readonly franchiseCarrierComponent = {
        carrierActivatedSuccessfully: 'Carrier activated Successfully',
        carrierDeactivatedSuccessfully: 'Carrier Deactivated Successfully'
    };

    static readonly rfqComponent = {
        titleText: 'Reject Reasons',
        labelText: 'Select rfq reject reason',
        rfqRejectionSubject: 'RFQ Rejected ->',
        rfqEmailSubject: 'Craters & Freighters Quote Request Update',
    };

    static readonly contactListConstants = {
        primaryContactWarning: 'Contact is found to be primary. To Deactivate this contact, need to change primary contact of this Account',
        contactActivatedMessage: 'Contact activated Successfully',
        contactDeactivatedMessage: 'Contact Deactivated Successfully',
        contactNotAssociated: 'Contact not associated',
        removeFromAddressConfirmation: `You want to remove the From Address?`,
        removeToAddressConfirmation: `You want to remove the To Address?`,
        removeBillToAddressConfirmation: `You want to remove the Bill To Account?`,
        removeIntermediaryAddressConfirmation: `You want to remove the Intermediary Address?`,
        unableToLoadRoutes: 'Unable to load routes, Please try later',
        toDeactivateContactChangeAccount: 'Contact is found to be primary. To Deactivate this contact, need to change primary contact of this Account',
        contactUpdatedSuccessfully: 'Contact updated successfully.',
        contactAddedSuccessfully: 'Contact added successfully.',
        duplicationOfPhoneTypes: 'Duplication of phone types',
        enterOfficePhone: 'Enter Office Phone',
        enterOtherPhone: 'Enter Other Phone',
        enterFax: 'Enter Fax'
    };

    static readonly errorMessageConstants = {
        errorMessageRetry: 'Something Went wrong, Please Re-try.',
        errorMessageSelectFranchise: 'Please select franchise'
    };

    static readonly orderPreviewDialogComponent = {
        bookingConfirmation: 'Are you Sure you want to proceed with the booking ?'
    };

    static readonly quickCutSheetComponent = {
        removeContainerConfirmation: 'You want to remove the container ?',
        removeAllContainerConfirmation: 'You want to remove the all container ?',
        warningMessageForEmptySelection: 'Please select at-least one container or packaging or a Pallet/floater for item number'
    };

    static readonly appointmentFormConstant = {
        removeAppointmentConfirmation: 'You want to remove appointment.',
        appointmentRemovedSuccessfully: 'Appointment removed successfully.',
        month: 'month',
        viewChange: 'view-change',
        day: 'day',
        week: 'week',
        today: 'today',
        next: 'next',
        prev: 'prev',
        showDate: 'show-date',
        selectDate: 'select-date'
    };

    static readonly orderStatusConstants = {
        allJobs: 'all-jobs',
        accepted: 'accepted',
        pickup: 'pickup',
        redims: 'redims',
        inshop: 'inshop',
        complete: 'complete',
        carrierPickup: 'carrierpickup',
        intransit: 'intransit',
        delivered: 'delivered',
        holdAndStorage: 'holdandstorage',
        allQuotes: 'all-quotes',
        quickQuotes: 'quick-quotes',
        quotes: 'quotes',
        draft: 'draft',
        sentForProposal: 'sentforproposal',
        negotiate: 'negotiate',
        lost: 'lost',
        exessValued: 'exessvalued',
        finalized: 'finalized',
        notFinalized: 'notfinalized'
    };

    static readonly colorConstants = {
        red: 'red',
        yellow: 'yellow',
        green: 'green',
        grey: 'grey'
    };

    static readonly orderCommonConstants = {
        cloneSuccessfully: 'Order clone successfully',
        doYouWantToClone: ' Do you want to clone?',
        existingClone: 'Clone Existing',
        cloneCurrentCost: 'Clone W/ Current Costs',
        convertedToJobSuccessfully: 'Quote converted to Job successfully',
        convertedToJobAndLeadToCustomer: `Quote will be converted to Job and Lead Account to Customer?`,
        existingCloneTooltip: 'Existing set of data and Cost will be used in the new Quote.',
        cloneCurrentCostTooltip: 'Existing set of data will be used however new calculations will be executed. Costs may vary from the existing Order',
        billToshouldBeFullAccount: 'Bill to Account Must be a Full Account',
        finalizedSuccessfully: 'This job has been closed successfully.'
    };

    static readonly finalDimsRoutingComponent = {
        jobDimsChangedToFinalDims: 'Jobs Dims will be changed to Final Dims. Do you want to continue ?',
        discardTheChanges: 'Are you sure? Discard the changes?',
        pleaseReQuote: 'BOL data entry grid is updated, please requote',
        jobDims: 'Job Dims',
        finalDims: 'Final Dims',
        pleaseAddBillToInformation: 'Full Account is required in Bill To section to complete Booking',
    };

    static readonly dimensionsConstants = {
        quantity: 'quantity',
        unit: 'unit',
        total: 'total',
        length: 'length',
        width: 'width',
        height: 'height'
    };

    static readonly documentConstants = {
        documentNotAvailable: 'Document Not Available. Please Contact Your Admin'
    };

    static readonly freightShopperConstants = {
        shippingCost: 'shippingCost',
        pleaseSelectClassType: 'Please Select Class Type',
        pleaseSelectPkgType: 'Please Select Package Type'
    };

    static readonly imageConstants = {
        max5Image: 'Max 5 images can be added.',
        pleaseSelectClassType: 'Invalid file Format!',
        imageDeleteConfirmation: 'Are you sure you want to delete the Image'
    };

    static readonly totalEstimateCategoryNameConstants = {
        materials: 'Materials',
        labor: 'Labor',
        services: 'services',
        insurance: 'Insurance',
        shipping: 'Shipping'
    };

    static readonly crossedThresholdBoundaryConstants = {
        crossedThresholdBoundary:
            "This change has crossed a threshold boundary requiring a change in packaging configuration and crate. Would you like to change packaging configuration and crate type?",
        crossedDefaultBoundary:
            "Changed value is less than threshold value requiring a change in crate & packaging configuration. Would you like to change packaging configuration and crate type?",
    };

    static readonly updateOrderModifierNotificationConstants = {
        updateJobOrderModifierNotification: "Job Updated  Successfully",
        updateQuoteOrderModifierNotification: "Quote Updated  Successfully",
        updateQuoteJobOrderModifierNotification:
            "Quote/Job Updated  Successfully",
    };

    static readonly zipcodeTemplateBlobURL = {
        zipcodeTemplate: 'https://bitv5blobqa.blob.core.windows.net/admindocuments/ZIP%20Code%20upload%20Template.xlsx',
        fileName: 'ZIP Code upload Template.xlsx',
    }

    static readonly formTypeConstants = {
        add: 'add',
        edit: 'edit'
    }

    static readonly dateChangeConstants = {
        fromDateErrorMessage: 'From date can\'t be greater then to.',
        toDateErrorMessage: 'To date can\'t be less then from.',
        start: 'start',
        end: 'end'
    }

    static readonly jobQuoteContants = {
        billToDetailsRequired: 'Bill to details required',
        billToShouldBeFullAccount: 'Bill to should be a full account',
        quoteConvertedToJob: 'Quote will be converted to job, Client information and Bill to Lead Account to Customer',
        quoteConvertToJobSuccessMessage: 'Quote converted to Job successfully',
        fullAccountRequiredMessage: 'You need a Full Account in the Bill To to convert to a job',
        billToIsMandatory: 'Bill to Account is required',
        selectFranchise: 'Please select franchise'
    }

    static readonly revenueCategoryNameConstants = {
        freight: 'Freight',
        pickup: 'Pick-Up',
        delivery: 'Delivery',
        packagingAndCrating: 'Packaging & Crating',
        hazmat: 'HazMat Services',
        insurance: 'Insurance',
        other: 'Other'
    };

}
